export const API_KEY = "25f25dab-635c-4b61-9f81-19f3baab8e25";
export const API_URL = "https://v2.api.noroff.dev/holidaze";
